import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tabs-specs',
  templateUrl: './tabs-specs.component.html',
  styleUrls: ['./tabs-specs.component.sass']
})
export class TabsSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/tabs/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
